// actions.ts
import { createAction, props } from '@ngrx/store';

// Generic Actions
export const loadList = createAction(
  '[List] Load List',
  props<{ listType: string }>()
);
export const loadListSuccess = createAction(
  '[List] Load List Success',
  props<{ listType: string, items: any[] }>()
);
export const loadListFailure = createAction(
  '[List] Load List Failure',
  props<{ listType: string, error: any }>()
);
// Action for handling success with an object response
export const loadObjectSuccess = createAction(
  '[List] Load Object Success',
  props<{ listType: string; data: any }>()
);

